import { type FormatAddressProps, formatAddress } from './formatAddress'

export function formatAddressInline(props: FormatAddressProps): string {
  return formatAddress(props).join(', ')
}
